import { getGlobalConfig } from "./global-config.model";


export interface UiStringModel {
    stateLabel: string;
    postCodeLabel: string;
    cityLabel: string;
    collectAddress2: boolean;
    address2Label: string;
    collectState: boolean;
    currency: string;
    systemName: string;
    dateFormat: string;
    currencyCode: string;
    isoRegionCode: string;
    receiveUpdatesTickboxEnabled: boolean;
    organiserSpelling: string;
    expirySpelling: string;
    brand: string;
    eventSitePath: string;
}

export const getUiStrings = (): UiStringModel => {
  return getGlobalConfig().uiStrings;
}

